import React from 'react';

import { useUserTableQuery } from 'generated/graphql';



export type IPersonRow = {
  id: string;
  fullName: string;
  preferredEmail: string;
  phone: string;
  active: boolean;
  superAdmin: boolean;
  createdOn: string;
};

export interface IData {
  rows: Array<IPersonRow>;
}

export function useQuery(organizationId?: string) {
  const tuple = useUserTableQuery({
    variables: {
      options: {
        filter: {
          organizationId
        }
      }
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        rows: tuple.data?.persons.map((node) => ({
          id: node.id,
          fullName: `${node.firstName} ${node.lastName}`,
          preferredEmail: node.preferredEmail,
          active: node.isActive,
          phone: node.phoneNumber,
          superAdmin: node.siteUser?.isSuperAdmin ?? false,
          createdOn: node.createdTimestamp.toFormat('yyyy-MM-dd')
        })) ?? []
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
